import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import Cronometro from "../../components/Cronometro/Cronometro";
import DashboardEstatisticas from "../../components/DashboardEstatisticas/DashboardEstatisticas";
import {
  getDadosJogo,
  vitoriaTime1,
  vitoriaTime2,
  atualizarTimeComReservas,
  getJogadoresTime1,
  getJogadoresTime2,
  getJogadoresProxReservas,
  clearTime1,
  clearTime2,
  clearProxReservas,
  saveTime1,
  saveTime2,
  saveProxReservas,
  getTeamVictories,
  setTeamVictories,
  handleDrawRotation,
  ambosSaemRotation,
  atualizarMultiplosJogadoresPorIdFixo,
  getGoleiros,
  definirGoleiroAPartirDaReserva,
  removerGoleiroParaReservas,
  clearGoleiros,
  setGoleiro,
} from "../../../db/db";
import { calcularPontuacaoPartida } from "../../../utils/performance";
import TimesEmCampo from "../../components/TimesEmCampo/TimesEmCampo";
import ListaReservas from "../../components/ListaReservas/ListaReservas";
import "./JogoEmAndamento.css";
import { Footer } from "../../components/Footer/Footer";

const JogoEmAndamento = () => {
  const navigate = useNavigate();
  const [jogo, setJogo] = useState([]);
  const [time1, setTime1] = useState([]);
  const [time2, setTime2] = useState([]);
  const [proxReservas, setProxReservas] = useState([]);
  const [goleiroTime1, setGoleiroTime1] = useState(null);
  const [goleiroTime2, setGoleiroTime2] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalStage, setModalStage] = useState("initial"); // 'initial' or 'maxVictories'
  const [timeVencedor, setTimeVencedor] = useState(null);
  const [refreshVictories, setRefreshVictories] = useState(false);
  const [resetTimerTrigger, setResetTimerTrigger] = useState(false);
  const [resetGolsTrigger, setResetGolsTrigger] = useState(false);
  const [corTime1, setCorTime1] = useState("");
  const [corTime2, setCorTime2] = useState("");
  const [placarAtual, setPlacarAtual] = useState({ time1: 0, time2: 0 });
  const [contribuicoesPartida, setContribuicoesPartida] = useState({});
  const [placarTeveAlteracao, setPlacarTeveAlteracao] = useState(false);
  const [statsRefreshToken, setStatsRefreshToken] = useState(0);
  const [hasRollback, setHasRollback] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ""; // Necessário para que o prompt de confirmação seja exibido na maioria dos navegadores
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleScoreChange = useCallback((novoPlacar = {}) => {
    const normalizar = (valor) =>
      typeof valor === "number" && !Number.isNaN(valor) ? valor : 0;
    setPlacarAtual((anterior) => {
      const atualizado = {
        time1: normalizar(novoPlacar.time1),
        time2: normalizar(novoPlacar.time2),
      };
      if (
        atualizado.time1 !== anterior.time1 ||
        atualizado.time2 !== anterior.time2
      ) {
        setPlacarTeveAlteracao(true);
      }
      return atualizado;
    });
  }, []);

  const atualizarGoleiros = useCallback(async () => {
    try {
      const goleiros = await getGoleiros();
      setGoleiroTime1(goleiros.time1 || null);
      setGoleiroTime2(goleiros.time2 || null);
    } catch (error) {
      console.error("Erro ao atualizar goleiros:", error);
    }
  }, []);

  useEffect(() => {
    atualizarGoleiros();
  }, [atualizarGoleiros]);

  const registrarJogada = ({ idGol, idAssist }) => {
    if (!idGol && !idAssist) {
      return;
    }
    setContribuicoesPartida((prev) => {
      const proximo = { ...prev };
      if (idGol) {
        const atual = proximo[idGol] || { gols: 0, assistencias: 0 };
        proximo[idGol] = {
          gols: atual.gols + 1,
          assistencias: atual.assistencias,
        };
      }
      if (idAssist) {
        const atual = proximo[idAssist] || { gols: 0, assistencias: 0 };
        proximo[idAssist] = {
          gols: atual.gols,
          assistencias: atual.assistencias + 1,
        };
      }
      return proximo;
    });
    setStatsRefreshToken((prev) => prev + 1);
  };

  const resetContextoPartida = () => {
    setContribuicoesPartida({});
    setPlacarAtual({ time1: 0, time2: 0 });
    setPlacarTeveAlteracao(false);
  };

  const montarAtualizacoesPorResultado = (
    jogadoresLista,
    resultado,
    cleanSheet
  ) => {
    if (!Array.isArray(jogadoresLista) || jogadoresLista.length === 0) {
      return [];
    }
    const camposBase =
      resultado === "win"
        ? { vitorias: 1 }
        : resultado === "loss"
          ? { derrotas: 1 }
          : { empates: 1 };
    return jogadoresLista.reduce((acc, jogador) => {
      if (!jogador?.id_fixo) {
        return acc;
      }
      acc.push({
        id_fixo: jogador.id_fixo,
        campo: "qt_partidas",
        valor: 1,
      });
      Object.entries(camposBase).forEach(([campo, valor]) => {
        acc.push({
          id_fixo: jogador.id_fixo,
          campo,
          valor,
        });
      });
      if (cleanSheet) {
        acc.push({
          id_fixo: jogador.id_fixo,
          campo: "jogosSemTomarGol",
          valor: 1,
        });
      }
      const contribuicoes = contribuicoesPartida[jogador.id_fixo] || {
        gols: 0,
        assistencias: 0,
      };
      const pontosParaVitoria = Math.max(
        1,
        Number.isFinite(jogo?.pontosParaAcabar) ? jogo.pontosParaAcabar : 1
      );
      const { pontuacao: score, influencia } = calcularPontuacaoPartida({
        gols: contribuicoes.gols || 0,
        assistencias: contribuicoes.assistencias || 0,
        resultado,
        cleanSheet,
        pontosParaVitoria,
      });
      if (score > 0) {
        acc.push({
          id_fixo: jogador.id_fixo,
          campo: "desempenhoAcumulado",
          valor: score,
        });
        if (resultado === "win" && influencia > 0) {
          acc.push({
            id_fixo: jogador.id_fixo,
            campo: "influenciaVitoria",
            valor: influencia,
          });
        }
      }
      return acc;
    }, []);
  };

  const houveRegistroPlacar = () =>
    placarTeveAlteracao || Object.keys(contribuicoesPartida).length > 0;

  const handleTime1Vencedor = async () => {
    try {
      salvarEstadoPartida(time1, time2, proxReservas, goleiroTime1, goleiroTime2);
      await registrarResultado("time1");
      const timeToUpdate = await vitoriaTime1(
        jogo.maxVictories,
        jogo.jogadoresPorTime
      );
      await atualizarTimeComReservas(timeToUpdate, jogo.jogadoresPorTime);
      await atualizarDadosDosTimes();

      setRefreshVictories((prev) => !prev);
      setResetTimerTrigger((prev) => !prev);
      setResetGolsTrigger((prev) => !prev);
      closeModal();
    } catch (error) {
      console.error("Erro ao atualizar as reservas e o time 2:", error);
    }
  };

  const handleTime2Vencedor = async () => {
    try {
      salvarEstadoPartida(time1, time2, proxReservas, goleiroTime1, goleiroTime2);
      await registrarResultado("time2");
      const timeToUpdate = await vitoriaTime2(
        jogo.maxVictories,
        jogo.jogadoresPorTime
      );
      await atualizarTimeComReservas(timeToUpdate, jogo.jogadoresPorTime);
      await atualizarDadosDosTimes();

      setRefreshVictories((prev) => !prev);
      setResetTimerTrigger((prev) => !prev);
      setResetGolsTrigger((prev) => !prev);
      closeModal();
    } catch (error) {
      console.error("Erro ao atualizar as reservas e o time 1:", error);
    }
  };

  const handleVitoria = async (time) => {
    let currentVictories = await getTeamVictories(time);
    if (!currentVictories || typeof currentVictories.victories !== "number") {
      currentVictories = { victories: 0 };
    }
    if (
      jogo.maxVictories > 0 &&
      currentVictories.victories + 1 >= jogo.maxVictories
    ) {
      setTimeVencedor(time);
      setModalStage("maxVictories");
    } else {
      if (time === "time1") {
        handleTime1Vencedor();
      } else {
        handleTime2Vencedor();
      }
    }
  };

  const handleAmbosSaem = async () => {
    salvarEstadoPartida(time1, time2, proxReservas, goleiroTime1, goleiroTime2);
    await registrarResultado(timeVencedor);
    await ambosSaemRotation(timeVencedor, jogo.jogadoresPorTime);
    await atualizarDadosDosTimes();
    setRefreshVictories((prev) => !prev);
    setResetTimerTrigger((prev) => !prev);
    setResetGolsTrigger((prev) => !prev);
    closeModal();
  };

  const handleVencedorSai = async () => {
    await registrarResultado(timeVencedor);

    let timeAPreencher;
    if (timeVencedor === "time1") {
      timeAPreencher = await vitoriaTime1(
        jogo.maxVictories,
        jogo.jogadoresPorTime
      );
    } else {
      timeAPreencher = await vitoriaTime2(
        jogo.maxVictories,
        jogo.jogadoresPorTime
      );
    }
    await atualizarTimeComReservas(timeAPreencher, jogo.jogadoresPorTime);
    await finalizarVitoria();
  };

  const finalizarVitoria = async () => {
    salvarEstadoPartida(time1, time2, proxReservas, goleiroTime1, goleiroTime2);
    await atualizarDadosDosTimes();
    setRefreshVictories((prev) => !prev);
    setResetTimerTrigger((prev) => !prev);
    setResetGolsTrigger((prev) => !prev);
    closeModal();
  };

  async function salvarEstadoPartida(time1, time2, proxReservas, goleiro1, goleiro2) {
    const partidasSalvas = JSON.parse(localStorage.getItem("partidas")) || [];
    // Busca as vitórias atuais dos times
    const victoriesTime1 = await getTeamVictories("time1");
    const victoriesTime2 = await getTeamVictories("time2");
    const estadoPartida = {
      time1,
      time2,
      proxReservas,
      goleiroTime1: goleiro1,
      goleiroTime2: goleiro2,
      victoriesTime1: victoriesTime1?.victories || 0,
      victoriesTime2: victoriesTime2?.victories || 0,
    };
    partidasSalvas.push(estadoPartida);
    localStorage.setItem("partidas", JSON.stringify(partidasSalvas));
    setHasRollback(true);
  }

  const handleEmpate = async () => {
    try {
      salvarEstadoPartida(time1, time2, proxReservas, goleiroTime1, goleiroTime2);
      await registrarEmpate();
      await handleDrawRotation(jogo.jogadoresPorTime);
      await atualizarDadosDosTimes();
      setRefreshVictories((prev) => !prev);
      setResetTimerTrigger((prev) => !prev);
      setResetGolsTrigger((prev) => !prev);
      closeModal();
    } catch (error) {
      console.error("Erro ao registrar empate:", error);
    }
  };

  const handleRollback = async () => {
    const confirmacao = window.confirm(
      "⚠️ ATENÇÃO: Esta ação irá desfazer a última partida!\n\n" +
      "Isso irá:\n" +
      "• Restaurar as posições dos jogadores\n" +
      "• Reverter as estatísticas da partida\n" +
      "• Voltar o placar dos times\n\n" +
      "Tem certeza que deseja continuar?"
    );

    if (!confirmacao) {
      return; // Usuário cancelou
    }

    const partidasSalvas = JSON.parse(localStorage.getItem("partidas")) || [];

    if (partidasSalvas.length < 1) {
      alert("Não há estados anteriores para restaurar!");
      setHasRollback(false);
      return;
    }

    const ultimoEstado = partidasSalvas.pop();
    localStorage.setItem("partidas", JSON.stringify(partidasSalvas));
    setHasRollback(partidasSalvas.length > 0);

    setContribuicoesPartida({});
    setPlacarAtual({ time1: 0, time2: 0 });
    setPlacarTeveAlteracao(false);
    setTime1(ultimoEstado.time1);
    setTime2(ultimoEstado.time2);
    setProxReservas(ultimoEstado.proxReservas);
    setGoleiroTime1(ultimoEstado.goleiroTime1 || null);
    setGoleiroTime2(ultimoEstado.goleiroTime2 || null);

    // Restaura as vitórias dos times
    if (typeof ultimoEstado.victoriesTime1 === "number") {
      await setTeamVictories("time1", ultimoEstado.victoriesTime1);
    }
    if (typeof ultimoEstado.victoriesTime2 === "number") {
      await setTeamVictories("time2", ultimoEstado.victoriesTime2);
    }

    try {
      await clearTime1();
      await clearTime2();
      await clearProxReservas();
      await clearGoleiros();

      await saveTime1(ultimoEstado.time1);
      await saveTime2(ultimoEstado.time2);
      await saveProxReservas(ultimoEstado.proxReservas);
      if (ultimoEstado.goleiroTime1) {
        await setGoleiro("time1", ultimoEstado.goleiroTime1);
      }
      if (ultimoEstado.goleiroTime2) {
        await setGoleiro("time2", ultimoEstado.goleiroTime2);
      }

      await atualizarDadosDosTimes();
      setRefreshVictories((prev) => !prev);

      alert("✅ O estado foi restaurado com sucesso!");
    } catch (error) {
      console.error("Erro ao atualizar o IndexedDB:", error);
      alert("❌ Houve um erro ao sincronizar com o banco de dados.");
    }
  };

  const atualizarDadosDosTimes = useCallback(async () => {
    try {
      const novoTime1 = await getJogadoresTime1();
      const novoTime2 = await getJogadoresTime2();
      const novosReservas = await getJogadoresProxReservas();

      setTime1(novoTime1);
      setTime2(novoTime2);
      setProxReservas(novosReservas);
      await atualizarGoleiros();
    } catch (error) {
      console.error("Erro ao atualizar os dados dos times:", error);
    }
  }, [atualizarGoleiros]);

  const atualizarReservas = useCallback(async () => {
    const reservasAtualizadas = await getJogadoresProxReservas();
    setProxReservas(reservasAtualizadas);
    await atualizarGoleiros();
  }, [atualizarGoleiros]);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const dadosJogo = await getDadosJogo();
        const reservasIniciais = await getJogadoresProxReservas(); // Busca inicial dos reservas
        if (dadosJogo.length > 0) {
          setJogo(dadosJogo[0]);
          setCorTime1(dadosJogo[0].corTime1);
          setCorTime2(dadosJogo[0].corTime2);
        } else {
          console.log("Nenhum jogo encontrado.");
        }

        await atualizarDadosDosTimes();
        setProxReservas(reservasIniciais); // Configura os reservas na inicialização
        const partidasSalvas = JSON.parse(localStorage.getItem("partidas")) || [];
        setHasRollback(partidasSalvas.length > 0);
      } catch (error) {
        console.error("Erro ao recuperar os dados iniciais:", error);
      }
    };
    fetchInitialData();
  }, [atualizarDadosDosTimes]);

  const handleSelecionarGoleiro = async (time, reservaId) => {
    const timeKey = time === 1 ? "time1" : "time2";
    const resultado = await definirGoleiroAPartirDaReserva(timeKey, reservaId);
    if (!resultado?.sucesso) {
      alert("Não foi possível definir o goleiro agora.");
      return;
    }
    await atualizarReservas();
  };

  const handleRemoverGoleiro = async (time) => {
    const timeKey = time === 1 ? "time1" : "time2";
    await removerGoleiroParaReservas(timeKey);
    await atualizarReservas();
  };

  const openModal = () => {
    setIsModalOpen(true);
    setModalStage("initial");
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalStage("initial");
    setTimeVencedor(null);
  };

  useEffect(() => {
    atualizarReservas();
  }, [atualizarReservas]);

  const isTurmaContext = jogo?.contexto === "turma";
  const relatorioPath = isTurmaContext
    ? `/turmas/${jogo.turmaId}/jogos/${jogo.jogoTurmaId}/relatorio`
    : "/relatorio-final";

  const registrarResultado = async (timeVencedor) => {
    const vencedores =
      timeVencedor === "time1"
        ? [...time1, ...(goleiroTime1 ? [goleiroTime1] : [])]
        : [...time2, ...(goleiroTime2 ? [goleiroTime2] : [])];
    const perdedores =
      timeVencedor === "time1"
        ? [...time2, ...(goleiroTime2 ? [goleiroTime2] : [])]
        : [...time1, ...(goleiroTime1 ? [goleiroTime1] : [])];
    const registroValido = houveRegistroPlacar();
    const cleanSheetVencedor =
      registroValido &&
      (timeVencedor === "time1"
        ? placarAtual.time2 === 0
        : placarAtual.time1 === 0);
    const cleanSheetPerdedor =
      registroValido &&
      (timeVencedor === "time1"
        ? placarAtual.time1 === 0
        : placarAtual.time2 === 0);

    const atualizacoes = [
      ...montarAtualizacoesPorResultado(
        vencedores,
        "win",
        cleanSheetVencedor
      ),
      ...montarAtualizacoesPorResultado(
        perdedores,
        "loss",
        cleanSheetPerdedor
      ),
    ];

    if (atualizacoes.length > 0) {
      await atualizarMultiplosJogadoresPorIdFixo(atualizacoes);
    }
    setStatsRefreshToken((prev) => prev + 1);
    resetContextoPartida();
  };

  const registrarEmpate = async () => {
    const registroValido = houveRegistroPlacar();
    const zeroZero = placarAtual.time1 === 0 && placarAtual.time2 === 0;
    const cleanSheetTime1 =
      placarAtual.time2 === 0 && (registroValido || zeroZero);
    const cleanSheetTime2 =
      placarAtual.time1 === 0 && (registroValido || zeroZero);

    const atualizacoes = [
      ...montarAtualizacoesPorResultado(
        [...time1, ...(goleiroTime1 ? [goleiroTime1] : [])],
        "draw",
        cleanSheetTime1
      ),
      ...montarAtualizacoesPorResultado(
        [...time2, ...(goleiroTime2 ? [goleiroTime2] : [])],
        "draw",
        cleanSheetTime2
      ),
    ];

    if (atualizacoes.length > 0) {
      await atualizarMultiplosJogadoresPorIdFixo(atualizacoes);
    }
    setStatsRefreshToken((prev) => prev + 1);
    resetContextoPartida();
  };

  return (
    <>
      <Header />

      <div className="body">
        <div className="center">
          <div className="body-content card">
            <div className="topo-page">
              <strong>
                {isTurmaContext
                  ? `# ${jogo.turmaNome || "Turma"} | Jogo`
                  : `# Amistoso | ${jogo.nome || ""}`}
              </strong>
            </div>

            <div className="area-jogo">
              <Cronometro
                resetTimerTrigger={resetTimerTrigger}
                setResetTimerTrigger={setResetTimerTrigger}
              />
              <TimesEmCampo
                time1Atualizado={time1}
                time2Atualizado={time2}
                reservasAtualizados={proxReservas}
                onReservasAtualizadas={atualizarReservas}
                goleiroTime1={goleiroTime1}
                goleiroTime2={goleiroTime2}
                onDefinirGoleiro={handleSelecionarGoleiro}
                onRemoverGoleiro={handleRemoverGoleiro}
                isDadosIndividuaisOn={jogo.dadosIndividuais}
                refreshVictories={refreshVictories}
                setRefreshVictories={setRefreshVictories}
                resetGolsTrigger={resetGolsTrigger}
                onColorChange={(team, color) => {
                  if (team === 1) setCorTime1(color);
                  else if (team === 2) setCorTime2(color);
                }}
                initialCorTime1={corTime1}
                initialCorTime2={corTime2}
                onScoreChange={handleScoreChange}
                onRegistrarJogada={registrarJogada}
              />

              <div className="botoes-controle-partida">
                <button className="btn-app" onClick={openModal}>
                  Finalizar JOGO
                </button>

                <button
                  className="btn-rollback"
                  onClick={handleRollback}
                  disabled={!hasRollback}
                  aria-disabled={!hasRollback}
                >
                  <img
                    width="25px"
                    src="/images/rollback.png"
                    alt="Voltar partida"
                  />
                </button>
              </div>

              <ListaReservas
                reservasAtualizados={proxReservas}
                onReservasAtualizadas={atualizarReservas}
                turmaId={isTurmaContext ? jogo.turmaId : null}
              />

              {jogo.dadosIndividuais && (
                <DashboardEstatisticas refreshToken={statsRefreshToken} />
              )}

              {/* Botão de encerrar sessão */}
              <div className="botao-encerrar-sessao">
                <button
                  className="btn-encerrar-sessao"
                  onClick={() => navigate(relatorioPath)}
                >
                  Encerrar Sessão
                </button>
              </div>

              {isModalOpen && (
                <div className="modal-overlay">
                  <div className="modal-content">
                    {modalStage === "initial" && (
                      <>
                        <h2>Quem VENCEU a partida?</h2>
                        <div className="modal-actions">
                          <button
                            onClick={() => handleVitoria("time1")}
                            className="modal-confirm"
                            style={{ "--btn-color": corTime1 }}
                          >
                            Time 1
                          </button>
                          <button
                            onClick={() => handleVitoria("time2")}
                            className="modal-confirm"
                            style={{ "--btn-color": corTime2 }}
                          >
                            Time 2
                          </button>
                          <button
                            onClick={handleEmpate}
                            className="modal-empate"
                          >
                            Empate
                          </button>
                        </div>
                      </>
                    )}
                    {modalStage === "maxVictories" && (
                      <>
                        <h2>O time vencedor atingiu o máximo de vitórias.</h2>
                        <div className="modal-actions">
                          <button
                            onClick={handleAmbosSaem}
                            className="modal-confirm"
                          >
                            Ambos saem
                          </button>
                          <button
                            onClick={handleVencedorSai}
                            className="modal-confirm"
                          >
                            Vencedor sai
                          </button>
                        </div>
                      </>
                    )}
                    <button onClick={closeModal} className="modal-cancel">
                      Cancelar
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default JogoEmAndamento;
